import React from 'react'
import { Container } from 'react-bootstrap';
import "./Road_Parivar_Banner.css";

function road_parivar_banner({fullscreen}) {
  return (
    <div className={`${fullscreen ? "container-fluid p-0" : "container"}`}>
      <div className="road-banner">
        <img 
          src="/assets/images/about_us/road_parivar.png" 
          alt="road-img" 
          className="road_parivar_img" 
        />

      </div>
    </div>
  )
}

export default road_parivar_banner